export default __webpack_public_path__ + "fonts/OpenSans-Bold-webfont.svg";